export enum TestExecutionStatus {
  SUCCESS = 'Success',
  FAILURE = 'Failure',
  WARNING = 'Warning',
  RUNNING = 'Running'
}

export type TestExecutionData = {
  id: string;
  test_execution_id: string;
  workflow_id: string;
  workflow_name: string;
  workflow_ticket_id: string;
  automation_flow_id: string;
  test_collection_name: string;
  test_collection_id: string;
  product_version: string;
  product_number: string;
  start_timestamp: string;
  duration: string;
  trigger_type: string;
  test_service_id: string;
  test_service_name: string;
  rapp_id: string;
  product_line: string;
  status: TestExecutionStatus;
};

export type TestExecution = {
  testExecutionId: string;
  workflowId: string;
  testCollection: string;
  createdAt: string;
  updatedAt: string;
  status: TestExecutionStatus;
};

// Test Data - will be removed
const statuses = Object.values(TestExecutionStatus);
const triggerTypes = ['manual', 'scheduled', 'webhook', 'api'];
const workflowNames = ['Smoke Test', 'Regression Test', 'Integration Test', 'Performance Test', 'Security Test'];
const testCollections = ['Core Features', 'API Tests', 'UI Tests', 'Database Tests', 'Network Tests'];
const productNumbers = ['CXP9012345', 'CXP9012346', 'CXP9012347', 'CXP9012348', 'CXP9012349'];

function generateDuration(): string {
  const minutes = Math.floor(Math.random() * 60);
  const seconds = Math.floor(Math.random() * 60);
  return `${minutes}m ${seconds}s`;
}

function generateTimestamp(): string {
  const now = new Date();
  const randomDays = Math.floor(Math.random() * 30);
  const randomHours = Math.floor(Math.random() * 24);
  const randomMinutes = Math.floor(Math.random() * 60);

  const timestamp = new Date(now.getTime() - randomDays * 24 * 60 * 60 * 1000 - randomHours * 60 * 60 * 1000 - randomMinutes * 60 * 1000);
  return timestamp.toISOString();
}

export function makeData(count: number): TestExecutionData[] {
  return Array.from({ length: count }, (_, i) => ({
    id: 'ba233a39-8beb-459e-99ba-f381d3121e0c',
    test_execution_id: `exec_${String(i + 1).padStart(6, '0')}`,
    test_collection_id: '',
    workflow_id: `T-170261`,
    workflow_name: workflowNames[Math.floor(Math.random() * workflowNames.length)],
    automation_flow_id: '',
    workflow_ticket_id: '',
    test_collection_name: testCollections[Math.floor(Math.random() * testCollections.length)],
    product_version: `${Math.floor(Math.random() * 5) + 1}.${Math.floor(Math.random() * 10)}.${Math.floor(Math.random() * 100)}`,
    product_number: productNumbers[Math.floor(Math.random() * productNumbers.length)],
    start_timestamp: generateTimestamp(),
    duration: generateDuration(),
    trigger_type: triggerTypes[Math.floor(Math.random() * triggerTypes.length)],
    test_service_id: '',
    test_service_name: '',
    rapp_id: 'CXP1324564-1',
    product_line: 'BNEW rApp',
    status: statuses[Math.floor(Math.random() * statuses.length)]
  }));
}
